import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
          准备好遇见更美的自己了吗？
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-50/80 max-w-md mx-auto">
          首次到店享受新生体验套餐优惠，仅需99元即可体验剪发+美妆+美甲一站式服务
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="bg-background-50 hover:bg-background-100 text-primary-600 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            立即预约
          </Link>
          <Link
            to="/services/packages"
            className="border border-background-50/50 hover:border-background-50 text-background-50 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            查看套餐
          </Link>
        </div>
      </div>
    </section>
  );
}